<template>
  <div class="gc-list-manage-wrap">
    <van-nav-bar :border="false"
                 title="管理"
    />
    <van-sticky>
      <div class="tab-project-wrap">
        <router-link class="item" v-for="(item,index) in tabbar" :key="index" :class="{'active': item.active}" :to="{name:item.link}" tag="div">
          {{ item.title }}
        </router-link>
      </div>
    </van-sticky>

    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      tabbar: [{
        title: '周ABC',
        link: 'WeekABC',
        active: true
      },
        {
          title: '日志管理',
          link: 'Log',
          active: false
        },
        {
          title: '经营早报',
          link: 'Help',
          active: false
        }]
    }
  },
  watch: {
    $route(to, from) {
      this.tabChange(to)
    }
  },
  mounted() {
    let to = this.$router.currentRoute
    this.tabChange(to)
  },
  methods: {
    tabChange(to) {
      for (let i = 0; i < this.tabbar.length; i++) {
        if (this.tabbar[i].link == to.name) {
          this.tabbar[i].active = true;
        } else {
          this.tabbar[i].active = false;
        }
      }
      if (to.name == 'MWeekABC') {
        this.tabbar[0].active = true;
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/base.less';

.gc-list-manage-wrap {
  padding-bottom: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/Manage.vue